import http from '@/utils/http'

export function getPractises(params){
    return http.get('/practises',{params})
}
export function addPractises(data){
    return http.post('/practises',data)
}
export function getPractisesDetail(id){
    return http.get(`/practises/${id}`)
}
export function putPractise(id,data){
    return http.put(`/practises/${id}`,data)
}
export function deletePractise(id){
    return http.delete(`/practises/${id}`)
}
export function gettopicsDistributionRequest(id,data){
    return http.post(`/topics/${id}/distribution_request`,data)
}


export function getMaterials(params){
    return http.get('/materials',{params})
}
export function addMaterials(data){
    return http.post('/materials',data)
}
export function deleteMaterials(id){
    return http.delete(`/materials/${id}`)
}
export function getPractisesDetailByAnswer(params){
    return  http(`/practisesByAnswer`,{params})
}